import {API} from "../../axios/axiosMainUrl";

const prefix = '/users/notes'
const prefixCategories = '/access-controls/user-access/note-categories'

export const notes = {
  state: {
    notes: [],
    notesCommonList: [],
    notesBtn: false,
    notesLoading: true,
    nextNotesPage: false,
    notesForPage: 25,
    notesFilter: '',

    noteCategories: [],
    noteCategoriesSelected: [],
  },

  mutations: {
    setNotesFilter: (state, payload) => {
      state.notesFilter = payload
    },

    setNotes: (state, payload) => {
      if(state.nextNotesPage) {
        state.notes = state.notes.concat(payload.notes)
      } else {
        state.notes = payload.notes
      }
    },

    setNotesCommonList: (state, payload) => {
      state.notesCommonList = payload.notesCommonList
    },

    setNextNotesPage: (state, payload) => {
      state.nextNotesPage = payload
    },

    setNoteCategories: (state, payload) => {
      state.noteCategories = payload.noteCategories
    },

    setNoteCategoriesSelected: (state, payload) => {
      state.noteCategoriesSelected = payload.noteCategoriesSelected
    },

    setNotesLoadingStart: (state) => {
      state.notesLoading = true
    },

    setNotesLoadingEnd: (state) => {
      state.notesLoading = false
    },

    changeNotesBtn: (state) => {
      state.notesBtn = true
    },
    successNotesBtn: (state) => {
      state.notesBtn = false
    },
  },

  getters: {
    getNotesFilter: state => {
      return state.notesFilter
    },

    getNotesForPage: state => {
      return state.notesForPage
    },

    getNotes: state => {
      return state.notes
    },

    getNotesLoading: state => {
      return state.notesLoading
    },

    getNextNotesPage: state => {
      return state.nextNotesPage
    },

    getNotesCommonList: state => {
      return state.notesCommonList
    },

    getNotesBtn: state => {
      return state.notesBtn
    },

    getNoteCategories: state => {
      return state.noteCategories
    },

    getNoteCategoriesSelected: state => {
      return state.noteCategoriesSelected
    },
  },

  actions: {

    async fetchNotes({commit, getters}, {filter = '', history = false}) {
      if(!getters.getNextNotesPage)
        commit('setNotesLoadingStart')
      try {
        return await API.get(`${prefix}${history ? '/history' : ''}${filter}`).then((response) =>{
          commit('setNotes',{notes: response.data.data.data})
          commit('setNotesCommonList',{notesCommonList: response.data.data})
          commit('setNotesLoadingEnd');
          return response;
        });
      } catch (e) {
        commit('setNotesLoadingEnd');
        return e;
      }
    },

    async createNotes({commit}, data) {
      commit('changeNotesBtn');
      try {
        return await API.post(`${prefix}`, data).then((response) =>{
          commit('successNotesBtn');
          return response;
        });
      } catch (e) {
        commit('successNotesBtn');
        return e;
      }
    },

    async deleteNotes({commit}, id) {
      try {
        return await API.delete(`${prefix}/${id}`).then((response) =>{
          return response;
        });
      } catch (e) {
        commit('successNotesBtn');
        return e;
      }
    },

    async fetchNoteCategories({commit}) {
      try {
        return await API.get(`${prefixCategories}`).then((response) =>{
          commit('setNoteCategories', {noteCategories: response.data.data['available-categories']})
          commit('setNoteCategoriesSelected', {noteCategoriesSelected: response.data.data['note-categories']})
          return response;
        });
      } catch (e) {
        return e;
      }
    },

    async updateNoteCategories({commit}, data) {
      try {
        return await API.put(`${prefixCategories}`, data).then((response) =>{
          commit('setNoteCategoriesSelected', {noteCategoriesSelected: response.data.data['note-categories']})
          return response;
        });
      } catch (e) {
        return e;
      }
    },

  }
}
